import { useContext, useState } from 'react'
import { Button } from '@/components/ui/button'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'
import { Email, EmailPreview } from 'api/Trading-Accounts/Types/EmailsDetailsDto'
import { StringTagsMultiSelect } from 'components/Select'
import { ChevronLeft } from 'lucide-react'
import { AuthSessionContext } from 'utils/AuthContext'
import { hasPermission } from 'utils/permissionsValidator'

import styles from './EmailPreviewModal.module.scss'

interface EmailPreviewModalProps {
  preview: EmailPreview
  emaildata: Email
  sendEmail: (cc: string[]) => Promise<void>
  goBack: () => void
}
export const EmailPreviewModal: React.FC<EmailPreviewModalProps> = (props) => {
  const { preview, emaildata, sendEmail, goBack } = props
  const [cc, setCc] = useState<string[]>([])
  const [auth] = useContext(AuthSessionContext)
  const permissions = auth?.permissions || []

  return (
    <div>
      <Button onClick={goBack} variant='outline' size='icon'>
        <ChevronLeft />
      </Button>
      <h1>Template: {emaildata.name}</h1>
      <h2>Subject: {preview.subject}</h2>
      <h3 className={styles.additional}>
        <StringTagsMultiSelect
          placeholder='Additional Receivers'
          value={cc}
          onChange={setCc}
          fullWidth
        />
        <Button
          disabled={!hasPermission(permissions, PermissionsEnum.CanSendTestEmails)}
          onClick={() => sendEmail(cc)}
        >
          Send Test Email
        </Button>
      </h3>
      <hr />
      <div dangerouslySetInnerHTML={{ __html: preview.body || '' }}></div>
    </div>
  )
}
